<ng-container *ngIf="canViewComunidad">

  <mat-expansion-panel fxFlex=100 fxFlex.xs=100 [expanded]="true" style="margin: 10px 0px;">
    <mat-expansion-panel-header>
      <mat-panel-title>
        <mat-icon style="margin-top: -3px; margin-right: 5px;">location_city</mat-icon>{{getTraduccion('Comunidad')}}
      </mat-panel-title>
      <mat-panel-description>
      </mat-panel-description>
    </mat-expansion-panel-header> 

    <ng-container *ngIf="isComunidadSearching">
      <mat-label><i class="fa fa-spinner fa-spin"></i> Cargando...</mat-label>
    </ng-container>

    <ng-container *ngIf="!isComunidadSearching && (comunidadList == null || comunidadList.length == 0)">
      <mat-label style="margin: 10px 0px;">No hay datos para mostrar.</mat-label>
      <ng-container *ngIf="canAddComunidad">
        <br/>
        <button mat-raised-button (click)="addComunidad()" color="primary" class="zb-button">Agregar {{getTraduccion('Comunidad').toLowerCase()}}</button>
      </ng-container>
    </ng-container>

    <div class="container-carousel" *ngIf="!isComunidadSearching && comunidadList != null && comunidadList.length > 0">
      
      <mat-card-content *ngFor="let item of comunidadList">
        
        <mat-card class="card-comunidad">
          <div class="card-content-comunidad">
            <div class="img-container">
              <img class="img-card" *ngIf="item.FotoPerfilUrl" src='{{item.FotoPerfilUrl}}' alt="">
              <img class="img-card" *ngIf="!item.FotoPerfilUrl" src='../../../../assets/edificio.default.webp' alt="">
            </div>
            <mat-card-header class="card-header-comunidad">
              <mat-card-title>{{item.Nombre }}</mat-card-title>
              <mat-card-subtitle> {{item.Direccion}} </mat-card-subtitle>
              <mat-card-subtitle class="mat-card-subtitle-1" (click)="verDetalle(item.Id)">Ver Detalles
              </mat-card-subtitle>
              
            </mat-card-header>
          </div>
        </mat-card>
        
      </mat-card-content>

    </div>

  </mat-expansion-panel>

</ng-container>
